const downloadFileFromBlobUrl = (blobUrl: string, filename: string) => {
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(blobUrl);
};

export const downloadFileFromString = (
  str: string,
  filename: string,
  fileMimeType: string,
): void => {
  const file = new File([str], filename, { type: fileMimeType });

  const url = window.URL.createObjectURL(file);

  downloadFileFromBlobUrl(url, filename);
};

export const downloadFileFromUrl = async (url: string, filename: string) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  const blob = await response.blob();
  const blobUrl = window.URL.createObjectURL(blob);

  downloadFileFromBlobUrl(blobUrl, filename);
};

type FileFormat = `.${string}`;

export const IMAGE_FORMATS: FileFormat[] = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.svg',
  '.heic',
];
export const VIDEO_FORMATS: FileFormat[] = [
  '.mp4',
  '.mov',
  '.avi',
  '.mkv',
  '.webm',
  '.ogv',
];
export const VIEWABLE_FORMATS: FileFormat[] = [
  ...IMAGE_FORMATS,
  ...VIDEO_FORMATS,
  '.pdf',
];
export const DOWNLOADABLE_FORMATS: FileFormat[] = []; // Empty array means all formats are downloadable

export enum ViewableContentType {
  IMAGE = 'image',
  VIDEO = 'video',
  PDF = 'pdf',
}

// Utility functions for content type detection
export const getContentTypeFromMimeType = (
  mimeType: string,
): ViewableContentType | null => {
  if (mimeType.startsWith('image/')) {
    return ViewableContentType.IMAGE;
  }
  if (mimeType.startsWith('video/')) {
    return ViewableContentType.VIDEO;
  }
  if (mimeType === 'application/pdf') {
    return ViewableContentType.PDF;
  }
  return null;
};
